<template>
    <div class="base-btn" v-if="withoutButton" @click="action()"><base-icon v-if="!withoutArrow" src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" class="mr-2" :color="'gray'" reverse/>{{ $t('back') }}</div>
    <base-button v-else @mouseover.native="hover = true" @mouseleave.native="hover = false" gray outline @click="action()"><base-icon v-if="!withoutArrow" src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" class="mr-2" :color="'gray'" reverse/>{{ $t('back') }}</base-button>
</template>

<script>
export default {
    name: 'back-button',
    props: {
        action: {
            type: Function,
            required: false,
            default () {
                history.back()
            }
        },
        withoutButton: Boolean,
        withoutArrow: Boolean
    },
    data () {
			return {
				hover: false
			}
    }
}
</script>

<style lang="scss" scoped>
.back-btn{
    @include media(mobile, tablets) {
        padding: .6rem 1rem;
    }
}
.base-btn{
    display: inline-block;
    color: $gray-600;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/base/buttons/BackButton.vue